import { ROUTE_NAME } from 'utils/constants/router';
import app from 'new-ui/app';
import { TAB_IDS } from './constants';

const GET_IS_TAB_ACTIVE_BY_TAB_ID = {
  [TAB_IDS.FEED]: () => app.isCurrentPage(ROUTE_NAME.FEED),
  [TAB_IDS.TREATMENT_OPTIONS]: () => app.isCurrentPage(ROUTE_NAME.RESULTS),
  [TAB_IDS.SUPPORT_PROGRAMS]: () => app.isCurrentPage(ROUTE_NAME.FINANCE),
  [TAB_IDS.SPEAK_WITH_TINA]: () => app.isCurrentPage(ROUTE_NAME.CHAT),
  [TAB_IDS.ARTICLES]: () => app.isCurrentPage(ROUTE_NAME.ARTICLES),
  [TAB_IDS.HCP_TREATMENT_OPTIONS]: () => app.isCurrentPage(ROUTE_NAME.SEARCH),
  [TAB_IDS.HCP_SUPPORT_PROGRAMS]: () => app.isCurrentPage(ROUTE_NAME.PUBLIC_FINANCE),
};

export const getActiveTab = (tabIds) => tabIds.find(
  (tabId) => (GET_IS_TAB_ACTIVE_BY_TAB_ID[tabId] ?? (() => false))(),
);
